import { InputType } from '../Enums/InputType';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';
import { ForceDirection } from '../Enums/ForceDirection';
import { Dictionary } from 'lodash';
import { Attribute } from './Attribute';

export class ToggleSlideOptions {
  /**
 * Represent Name Of Form Control
 */
  Name:string
   /**
 *   Represent classes to  ToggleSlide that allow us to select the ToggleSlide by jquery or javascript 
 */
 
  ExtraClasses:string
    /**
 *  Display validation message only on added repeater when add class "v-required"
 */
 ValidationClasses:string
 /**  Represent value of the label*/
  LabelValue:string
   /**  Represent Key of the label*/
   LabelKey:string
  /**  Represent value of the labelDescription show under ToggleSlide*/
  LabelDescription:string
  /**To set  value  to  ToggleSlide */
  Value:boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
   /** Set List of Custom Attribute to ToggleSlide  */
  AttributeList:Attribute[]
   /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
*/
CustomValidation: CustomValidation
ViewType:ControlLayout=ControlLayout.Vertical
ForceDirection: ForceDirection=ForceDirection.English
HideLabel:  boolean

}